


















import { Vue, Component, Watch } from "vue-property-decorator";
import { Action, State } from "vuex-class";
import ScriptPrompt from "@/components/ScriptPrompt/Prompt.vue";
import LeadPanel from "@/components/Lead/LeadPanel.vue";
import logger from "@/configs/logger";
import { objectify } from "@/helpers";
import { User } from "@/types";
import getCallConfig from "@/helpers/getCallConfig";

@Component({
  components: { ScriptPrompt, LeadPanel }
})
export default class CallView extends Vue {
  @Action("bindActiveLead") bindActiveLead!: Function;
  @State("taskAttributes") taskAttributes!: any;
  @State("scriptPromptPages") scriptPromptPages!: any[];
  @State("activeLead") activeLead!: any;
  @State("user") user!: User;

  @Watch("taskAttributes")
  onTaskAttributeChange(val: any, preVal: any) {
    if (!preVal || !Object.keys(preVal).length) {
      if (val.lead_key) {
        this.bindActiveLead();
      }
    }
  }

  async created() {
    this.bindActiveLead();
  }

  get scriptPageType() {
    const callConfig = getCallConfig(
      this.user.groups,
      this.taskAttributes.task_creation_source
    );
    return callConfig.script;
  }

  get lead() {
    return this.activeLead || {};
  }

  get showScriptPrompt(): boolean {
    if (!this.taskAttributes) {
      logger("warn", "missing task attributes");
    }
    if (!this.scriptPromptPages) {
      logger("warn", "missing script prompt page type");
    }
    if (Object.keys(this.lead).length) {
      logger("warn", "missing lead");
    }
    return (
      this.taskAttributes &&
      this.scriptPageType &&
      !!Object.keys(this.lead).length
    );
  }
}
